import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import type { ButtonProps } from '@xing-com/button';
import { Link } from '@xing-com/crate-core-router';
import { IconComment } from '@xing-com/icons';
import { scale110 } from '@xing-com/tokens';

export type CommentReactionButtonProps = ButtonProps &
  CommentReactionProps & {
    compact?: boolean;
    commentClick?(): void;
  };

export type CommentReactionProps = {
  to?: string;
  entryPoint?: string;
};

export const CommentReactionButton: FC<CommentReactionButtonProps> = ({
  onClick,
  compact = false,
  to,
  entryPoint,
}) =>
  to && (
    <StyledLink
      to={to}
      onClick={onClick}
      state={{ from: entryPoint }}
      data-testid="comment-button"
    >
      <IconComment width={scale110} />
      {!compact && <FormattedMessage id="COMMENT_BUTTON_LABEL" />}
    </StyledLink>
  );

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  color: inherit;

  &:hover,
  &:focus {
    text-decoration: inherit;
  }
`;
